import { Box } from '@material-ui/core';
import { Agent } from '@nemuru-eng/js-api-client';
import { useFormContext } from 'react-hook-form';

import { CheckboxFormField } from '@/components/shared/components/NewContextForms/CheckboxFormField';

import { CloneType } from '../types/CloneType';
import { SectionTitle } from './SectionTitle';

interface ConfigurationProps {
  type: CloneType;
  clonedAgent: Agent;
}

export const Configuration = ({ type, clonedAgent }: ConfigurationProps) => {
  const { watch } = useFormContext();

  const cloneCreateUser = watch('cloneCreateUser');

  return (
    <>
      <SectionTitle
        titleId={'CONFIGURATION_OPTIONS'}
        textId={type === CloneType.CLONE ? 'CONFIGURATION_OPTIONS_CLONE_TEXT' : 'CONFIGURATION_OPTIONS_UPDATE_TEXT'}
      />
      <Box px={1} minHeight={'200px'} display={'flex'} flexDirection={'column'}>
        <CheckboxFormField name={'cloneConfiguration'} label={'CLONE_CONFIGURATION'} />
        <CheckboxFormField name={'cloneAgentInLenderContext'} label={'CLONE_AGENT_IN_LENDER_CONTEXT'} />
        {clonedAgent.pricingIds && clonedAgent.pricingIds?.length > 0 && (
          <CheckboxFormField name={'clonePricings'} label={'CLONE_PRICINGS'} />
        )}
        <CheckboxFormField name={'cloneCreateUser'} label={'CLONE_CREATE_USER'} />
        <CheckboxFormField
          name={'sendPasswordRecovery'}
          label={'CLONE_SEND_PASSWORD_RECOVERY'}
          disabled={!cloneCreateUser}
        />
      </Box>
    </>
  );
};
